import { API_URL } from "env";

export interface UserPointData {
    wallet: number;
    wallet_use: number;
    point_balance: number;
    point_total: number;
    level: string;
    level_avatar: string;
    next_level: string;
    next_level_avatar: string;
    percent: number;
}

export interface UserPointAPIResponse {
    status: boolean;
    data: UserPointData;
}
async function getUserPoints(): Promise<UserPointAPIResponse | null> {
    if (!localStorage.getItem("token")) {
        return null;
    }

    const response = await fetch(API_URL.replace(/\/$/, "") + "/api/v1/fe/customer/points", {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${localStorage.getItem("token")}`,
        },
    });
    const data = await response.json();
    return data;
}

export { getUserPoints };